import {
    TenantUserRow,
    TenantUsersList,
} from 'modules/settings/pods/settings-user-location-assignment/settings-user-location-assignment.vm';
import { TenantUserApi, TenantUsersApiResponse } from './tenant-users.api';

const toDisplayName = (api: TenantUserApi): string => {
    const lastName = api.lastName?.trim() ?? '';
    const firstName = api.firstName?.trim() ?? '';

    if (lastName && firstName) {
        return `${lastName}, ${firstName}`;
    }

    return lastName || firstName || (api.username ?? '');
};

const toFullName = (api: TenantUserApi): string =>
    [api.firstName?.trim(), api.lastName?.trim()].filter(Boolean).join(' ') || (api.username ?? '');

export const mapTenantUserFromApiToVm = (api: TenantUserApi): TenantUserRow => ({
    id: api.id,
    username: api.username ?? '',
    displayName: toDisplayName(api),
    fullName: toFullName(api),
    email: api.email ?? '',
    active: api.active ?? false,
    isAdmin: api.admin ?? false,
    roles: api.roles ?? [],
    locations: (api.locations ?? []).map((location) => ({ id: location.id, name: location.name ?? null })),
});

export const mapTenantUsersFromApiToVm = (response: TenantUsersApiResponse): TenantUsersList => ({
    users: (response.users ?? []).map(mapTenantUserFromApiToVm),
});
